<template>
  <div class="MusicAlbum" v-if="album_list">
    <el-table
        height="600"
        ref="filterTable"
        :data="album_list"
        class="table">

      <el-table-column
          prop="album_name"
          label="Name"
          width="200">
      </el-table-column>

      <el-table-column
          prop="album_description"
          label="Description"
          width="300">
      </el-table-column>

      <el-table-column
          prop="music_count"
          label="Playlist"
          width="100">
      </el-table-column>

      <el-table-column
          prop="album_image"
          label="Thumbnail"
          width="250">
        <template slot-scope="scope">
          <el-image :src="scope.row.album_image" style="width:200px;height: 100px" fit="contain"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="">
        <template slot-scope="scope">
          <el-button
              size="mini"
              style="width: 70px"
              @click="onEdit(scope.row.album_name, scope.row.album_description, scope.row.album_id, scope.row.album_image)">
            Edit
          </el-button>
          <el-button
              size="mini"
              style="width: 70px"
              type="danger"
              @click="onDelete(scope.row.album_id)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button @click="dialog_visible = true" class="add" type="primary" size="medium" round="" icon="el-icon-plus">
      Create Album
    </el-button>
    <el-dialog width="35%" style="min-width: 1400px" title="Album" :visible.sync="dialog_visible">
      <div v-if="dialog_visible">
        <el-form v-if="dialog_visible" :model="item_holder" :rules="rules" ref="nameForm">
          <el-form-item label="Name" label-width="100px" prop="name">
            <el-input v-model="item_holder.name" style="width: 300px" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Description" label-width="100px" prop="description">
            <el-input v-model="item_holder.description" style="width: 300px" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Thumbnail" label-width="100px" prop="url">
            <ImageUpload style="max-width: 150px;overflow: hidden"
                         :limit="1" target="banner" :input="current_input"
                         @output="onUpdateImage"></ImageUpload>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="item_holder.url===''"
                     @click="onSave(item_holder.name,item_holder.description,item_holder.id,item_holder.url)">Save
          </el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import ImageUpload from "@/components/Images/Images";
  import {deleteAlbum, getAlbumList, saveAlbum} from "@/utils/api";

  export default {
    props: {},
    components: {
      ImageUpload
    },
    data: () => {
      return {
        album_list: false,
        dialog_visible: false,
        current_input: [],
        item_holder: {
          name: '',
          description: '',
          id: '',
          url: ''
        },
        rules: {
          name: [
            {required: true, message: 'Album name is required', trigger: 'blur'},
          ],
          description: [
            {required: true, message: 'Album description is required', trigger: 'blur'},
          ],
          url: [
            {required: true, message: 'Thumbnail is required', trigger: 'blur'},
          ],
        }
      }
    },
    watch: {
      dialog_visible: function (n) {
        if (!n) {
          this.item_holder = {
            name: '',
            description: '',
            id: '',
            url: ''
          };
          getAlbumList().then(res => {
            this.album_list = res.album_list
          })
        }
      },
    },
    methods: {
      onUpdateImage(e) {
        if (e.image_list.length === 0) {
          this.item_holder.url = ''
        } else {
          this.item_holder.url = e.image_list[0]
        }
      },
      onEdit(name, description, id, url) {
        this.item_holder = {
          name: name,
          description: description,
          id: id,
          url: url
        };
        this.dialog_visible = true;
        setTimeout(() => {
          this.current_input = [url];
        })
      },
      onDelete(id) {
        this.$confirm(`Are you sure to delete this album? Music files under this album won't be deleted.`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteAlbum(id).then(res => {
            if (res.errcode === 0) {
              this.$showLoading('Loading');
              this.$message.success('Album deleted');
              getAlbumList().then(res => {
                this.$hideLoading();
                this.album_list = res.album_list
              })
            } else {
              this.$message.error('Error');
            }
          })
        }).catch(() => {
        });
      },
      onSave(name, description, id, url) {
        this.$refs['nameForm'].validate((valid) => {
          if (valid) {
            saveAlbum(name, description, id, url).then(res => {
              if (res.errcode === 0) {
                this.$message.success(`Album ${id === '' ? 'created' : 'saved'}`);
              } else {
                this.$message.error('Error');
              }
              this.dialog_visible = false
            })
          } else {
            this.$message.error('Check your inputs');
            return false;
          }
        });
      },
    },
    beforeMount() {
      this.$showLoading('Loading');
      getAlbumList().then(res => {
        this.$hideLoading();
        this.album_list = res.album_list
      })
    },
  };

</script>

<style lang="scss" scoped>
  @import "_MusicAlbum.scss";
</style>